import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MdOutlineCancel } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { links, linksCliente, linksDropoff, linksPartner } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import sellAi from '../data/Logo-Biomap.jpg';
import { fetchUser } from '../utils/fetchUser';

const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();
  const userInfo = fetchUser();
  // Estado para controlar qué menús con subenlaces están expandidos
  const [expandedMenus, setExpandedMenus] = useState({});

  const handleToggle = (menuName) => {
    setExpandedMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const activeLink =
    'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-white text-md m-2';
  const normalLink =
    'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2';

  return (
    <div className="ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
          <div className="flex justify-between items-center">
            <Link
              to="/"
              onClick={handleCloseSideBar}
              className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-red-700"
            >
              <img src={sellAi} alt="LOGISTICA MAQUINARIA" className="h-18 w-24" />
              <span>{/*LOGITRACK*/}</span>
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="mt-10">
            {userInfo &&
              (userInfo.rol === 'Administrador'
                ? links
                : userInfo.rol === 'Partner'
                ? linksPartner
                : userInfo.rol === 'Drop-off'
                ? linksDropoff
                : userInfo.rol === 'Cliente'
                ? linksCliente
                : links
              ).map((item) => (
                <div key={item.title}>
                  <p className="text-gray-700 dark:text-gray-700 m-3 mt-4">
                    {item.title}
                  </p>
                  {item.links.map((link) => {
                    // Si el enlace tiene la propiedad 'children', mostramos el submenú
                    if (link.children && link.children.length > 0) {
                      return (
                        <div key={link.name}>
                          <div
                            onClick={() => handleToggle(link.name)}
                            className={
                              normalLink +
                              ' cursor-pointer flex justify-between items-center'
                            }
                          >
                            <div className="flex items-center gap-5">
                              {link.icon}
                              <span className="capitalize">{link.name}</span>
                            </div>
                            <div className="mr-4">
                              {/* Indicador de expansión (puedes cambiarlo por un icono) */}
                              {expandedMenus[link.name] ? '-' : '+'}
                            </div>
                          </div>
                          {expandedMenus[link.name] && (
                            <div className="ml-8">
                              {link.children.map((child) => (
                                <NavLink
                                  to={`/${child.name}`}
                                  key={child.name}
                                  onClick={handleCloseSideBar}
                                  style={({ isActive }) => ({
                                    backgroundColor: isActive ? currentColor : '',
                                  })}
                                  className={({ isActive }) =>
                                    isActive ? activeLink : normalLink
                                  }
                                >
                                  {child.icon}
                                  <span className="capitalize">{child.name}</span>
                                </NavLink>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    } else {
                      return (
                        <NavLink
                          to={`/${link.name}`}
                          key={link.name}
                          onClick={handleCloseSideBar}
                          style={({ isActive }) => ({
                            backgroundColor: isActive ? '#DCDCDC' : '',
                          })}
                          className={({ isActive }) =>
                            isActive ? activeLink : normalLink
                          }
                        >
                          {link.icon}
                          <span className="capitalize">{link.name}</span>
                        </NavLink>
                      );
                    }
                  })}
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
